<template>
  <!-- Page Content -->
  <div class="whole-page" id="overview-div">
    <AIChatFloat :colorTheme="colorTheme" />
    <div class="navbar-div">
      <Navbar
        analysis="OVERVIEW"
        :colorTheme="colorTheme"
        :layoutOptions="layoutOptions"
        :selectedLayout="overview_preferences['selectedLayout']"
        :showLayoutSelector="true"
        :user="user"
        @eventOnUserColorTheme="onUserColorTheme"
        @eventOnUserSelectLayout="onUserSelectLayout"
      />
    </div>
    <!-- {{ listeners }}, {{ listenerKeys }} -->
    <!-- {{ overview_preferences["currentLayout"] }} -->
    <div class="no_nav_height">
      <!-- {{ TAVisible }} -->
      <Layout1x1
        v-if="overview_preferences['selectedLayout'].value == '1x1'"
        :allData="allData0"
        :assetTypes="assetTypes"
        :colorTheme="colorTheme"
        :commoditySpecs="commoditySpecs"
        :componentNumber="1"
        :currencySpecs="currencySpecs"
        :currentLayout="overview_preferences['currentLayout'][0]"
        :etfSpecs="etfSpecs"
        :futuresSpecs="futuresSpecs"
        :indexSpecs="indexSpecs"
        :irSpecs="irSpecs"
        :message="message0"
        :nSelected="1"
        :processData="processData"
        :showLoadingComm="showLoadingComm"
        :showLoadingETF="showLoadingETF"
        :showLoadingFut="showLoadingFut"
        :showLoadingInd="showLoadingInd"
        :showLoadingIR="showLoadingIR"
        :TAVisible="TAVisible"
        :stopAssetType="stopAssetType"
        :verySmall="false"
        @emitSpreadTable="emitSpreadTable"
        @eventOnChangeTerm="onChangeTerm"
        @eventOnSelectedAssetType="onSelectedAssetType"
        @eventOnUserAssetSelection="onUserAssetSelection"
        @eventOnUserAssetSelectionList="onUserAssetSelectionList"
        @eventOnUserAsset2Selection="onUserAsset2Selection"
        @eventOnUserClearComponent="onUserClearComponent"
        @eventOnUserSelectVisualization="onUserSelectVisualization"
        @eventOnUserShowFields="onUserShowFields"
        @eventOnUserShowTAChart="onUserShowTAChart"
      />

      <Layout1p2
        v-else-if="overview_preferences['selectedLayout'].value == '1+2'"
        :allData0="allData0"
        :allData1="allData1"
        :allData2="allData2"
        :assetTypes="assetTypes"
        :colorTheme="colorTheme"
        :commoditySpecs="commoditySpecs"
        :componentNumber="1"
        :currencySpecs="currencySpecs"
        :currentLayout="overview_preferences['currentLayout'][0]"
        :etfSpecs="etfSpecs"
        :futuresSpecs="futuresSpecs"
        :indexSpecs="indexSpecs"
        :irSpecs="irSpecs"
        :message0="message0"
        :message1="message1"
        :message2="message2"
        :nSelected="1"
        :overview_preferences="overview_preferences"
        :processData="processData"
        :showLoadingComm="showLoadingComm"
        :showLoadingETF="showLoadingETF"
        :showLoadingFut="showLoadingFut"
        :showLoadingInd="showLoadingInd"
        :showLoadingIR="showLoadingIR"
        :TAVisible="TAVisible"
        :stopAssetType="stopAssetType"
        @emitSpreadTable="emitSpreadTable"
        @eventOnChangeTerm="onChangeTerm"
        @eventOnSelectedAssetType="onSelectedAssetType"
        @eventOnUserAssetSelection="onUserAssetSelection"
        @eventOnUserAssetSelectionList="onUserAssetSelectionList"
        @eventOnUserAsset2Selection="onUserAsset2Selection"
        @eventOnUserClearComponent="onUserClearComponent"
        @eventOnUserSelectVisualization="onUserSelectVisualization"
        @eventOnUserShowFields="onUserShowFields"
        @eventOnUserShowTAChart="onUserShowTAChart"
      />
      <Layout1x2
        v-else-if="overview_preferences['selectedLayout'].value == '1x2'"
        :allData0="allData0"
        :allData1="allData1"
        :assetTypes="assetTypes"
        :colorTheme="colorTheme"
        :commoditySpecs="commoditySpecs"
        :componentNumber="1"
        :currencySpecs="currencySpecs"
        :currentLayout="overview_preferences['currentLayout'][0]"
        :etfSpecs="etfSpecs"
        :futuresSpecs="futuresSpecs"
        :indexSpecs="indexSpecs"
        :irSpecs="irSpecs"
        :message0="message0"
        :message1="message1"
        :nSelected="1"
        :overview_preferences="overview_preferences"
        :processData="processData"
        :showLoadingComm="showLoadingComm"
        :showLoadingETF="showLoadingETF"
        :showLoadingFut="showLoadingFut"
        :showLoadingInd="showLoadingInd"
        :showLoadingIR="showLoadingIR"
        :TAVisible="TAVisible"
        :stopAssetType="stopAssetType"
        @emitSpreadTable="emitSpreadTable"
        @eventOnChangeTerm="onChangeTerm"
        @eventOnSelectedAssetType="onSelectedAssetType"
        @eventOnUserAssetSelection="onUserAssetSelection"
        @eventOnUserAssetSelectionList="onUserAssetSelectionList"
        @eventOnUserAsset2Selection="onUserAsset2Selection"
        @eventOnUserClearComponent="onUserClearComponent"
        @eventOnUserSelectVisualization="onUserSelectVisualization"
        @eventOnUserShowFields="onUserShowFields"
        @eventOnUserShowTAChart="onUserShowTAChart"
      />
      <Layout1x3
        v-else-if="overview_preferences['selectedLayout'].value == '1x3'"
        :allData0="allData0"
        :allData1="allData1"
        :allData2="allData2"
        :assetTypes="assetTypes"
        :colorTheme="colorTheme"
        :commoditySpecs="commoditySpecs"
        :componentNumber="1"
        :currencySpecs="currencySpecs"
        :currentLayout="overview_preferences['currentLayout'][0]"
        :etfSpecs="etfSpecs"
        :futuresSpecs="futuresSpecs"
        :indexSpecs="indexSpecs"
        :irSpecs="irSpecs"
        :message0="message0"
        :message1="message1"
        :message2="message2"
        :nSelected="1"
        :overview_preferences="overview_preferences"
        :processData="processData"
        :showLoadingComm="showLoadingComm"
        :showLoadingETF="showLoadingETF"
        :showLoadingFut="showLoadingFut"
        :showLoadingInd="showLoadingInd"
        :showLoadingIR="showLoadingIR"
        :TAVisible="TAVisible"
        :stopAssetType="stopAssetType"
        @emitSpreadTable="emitSpreadTable"
        @eventOnChangeTerm="onChangeTerm"
        @eventOnSelectedAssetType="onSelectedAssetType"
        @eventOnUserAssetSelection="onUserAssetSelection"
        @eventOnUserAssetSelectionList="onUserAssetSelectionList"
        @eventOnUserAsset2Selection="onUserAsset2Selection"
        @eventOnUserClearComponent="onUserClearComponent"
        @eventOnUserSelectVisualization="onUserSelectVisualization"
        @eventOnUserShowFields="onUserShowFields"
        @eventOnUserShowTAChart="onUserShowTAChart"
      />
      <Layout2p1
        v-else-if="overview_preferences['selectedLayout'].value == '2+1'"
        :allData0="allData0"
        :allData1="allData1"
        :allData2="allData2"
        :assetTypes="assetTypes"
        :colorTheme="colorTheme"
        :commoditySpecs="commoditySpecs"
        :componentNumber="1"
        :currencySpecs="currencySpecs"
        :currentLayout="overview_preferences['currentLayout'][0]"
        :etfSpecs="etfSpecs"
        :futuresSpecs="futuresSpecs"
        :indexSpecs="indexSpecs"
        :irSpecs="irSpecs"
        :message0="message0"
        :message1="message1"
        :message2="message2"
        :nSelected="1"
        :overview_preferences="overview_preferences"
        :processData="processData"
        :showLoadingComm="showLoadingComm"
        :showLoadingETF="showLoadingETF"
        :showLoadingFut="showLoadingFut"
        :showLoadingInd="showLoadingInd"
        :showLoadingIR="showLoadingIR"
        :stopAssetType="stopAssetType"
        :TAVisible="TAVisible"
        @emitSpreadTable="emitSpreadTable"
        @eventOnChangeTerm="onChangeTerm"
        @eventOnSelectedAssetType="onSelectedAssetType"
        @eventOnUserAssetSelection="onUserAssetSelection"
        @eventOnUserAssetSelectionList="onUserAssetSelectionList"
        @eventOnUserAsset2Selection="onUserAsset2Selection"
        @eventOnUserClearComponent="onUserClearComponent"
        @eventOnUserSelectVisualization="onUserSelectVisualization"
        @eventOnUserShowFields="onUserShowFields"
        @eventOnUserShowTAChart="onUserShowTAChart"
      />
      <Layout2x1
        v-else-if="overview_preferences['selectedLayout'].value == '2x1'"
        :allData0="allData0"
        :allData1="allData1"
        :assetTypes="assetTypes"
        :colorTheme="colorTheme"
        :commoditySpecs="commoditySpecs"
        :componentNumber="1"
        :currencySpecs="currencySpecs"
        :currentLayout="overview_preferences['currentLayout'][0]"
        :etfSpecs="etfSpecs"
        :futuresSpecs="futuresSpecs"
        :indexSpecs="indexSpecs"
        :irSpecs="irSpecs"
        :message0="message0"
        :message1="message1"
        :nSelected="1"
        :overview_preferences="overview_preferences"
        :processData="processData"
        :showLoadingComm="showLoadingComm"
        :showLoadingETF="showLoadingETF"
        :showLoadingFut="showLoadingFut"
        :showLoadingInd="showLoadingInd"
        :showLoadingIR="showLoadingIR"
        :TAVisible="TAVisible"
        :stopAssetType="stopAssetType"
        @emitSpreadTable="emitSpreadTable"
        @eventOnChangeTerm="onChangeTerm"
        @eventOnSelectedAssetType="onSelectedAssetType"
        @eventOnUserAssetSelection="onUserAssetSelection"
        @eventOnUserAssetSelectionList="onUserAssetSelectionList"
        @eventOnUserAsset2Selection="onUserAsset2Selection"
        @eventOnUserClearComponent="onUserClearComponent"
        @eventOnUserSelectVisualization="onUserSelectVisualization"
        @eventOnUserShowFields="onUserShowFields"
        @eventOnUserShowTAChart="onUserShowTAChart"
      />
      <Layout2x2
        v-else-if="overview_preferences['selectedLayout'].value == '2x2'"
        :allData0="allData0"
        :allData1="allData1"
        :allData2="allData2"
        :allData3="allData3"
        :assetTypes="assetTypes"
        :colorTheme="colorTheme"
        :commoditySpecs="commoditySpecs"
        :componentNumber="1"
        :currencySpecs="currencySpecs"
        :currentLayout="overview_preferences['currentLayout'][0]"
        :etfSpecs="etfSpecs"
        :futuresSpecs="futuresSpecs"
        :indexSpecs="indexSpecs"
        :irSpecs="irSpecs"
        :message0="message0"
        :message1="message1"
        :message2="message2"
        :message3="message3"
        :nSelected="1"
        :overview_preferences="overview_preferences"
        :processData="processData"
        :showLoadingComm="showLoadingComm"
        :showLoadingETF="showLoadingETF"
        :showLoadingFut="showLoadingFut"
        :showLoadingInd="showLoadingInd"
        :showLoadingIR="showLoadingIR"
        :TAVisible="TAVisible"
        :stopAssetType="stopAssetType"
        @emitSpreadTable="emitSpreadTable"
        @eventOnChangeTerm="onChangeTerm"
        @eventOnSelectedAssetType="onSelectedAssetType"
        @eventOnUserAssetSelection="onUserAssetSelection"
        @eventOnUserAssetSelectionList="onUserAssetSelectionList"
        @eventOnUserAsset2Selection="onUserAsset2Selection"
        @eventOnUserClearComponent="onUserClearComponent"
        @eventOnUserSelectVisualization="onUserSelectVisualization"
        @eventOnUserShowFields="onUserShowFields"
        @eventOnUserShowTAChart="onUserShowTAChart"
      />
      <Layout2x3
        v-else-if="overview_preferences['selectedLayout'].value == '2x3'"
        :allData0="allData0"
        :allData1="allData1"
        :allData2="allData2"
        :allData3="allData3"
        :allData4="allData4"
        :allData5="allData5"
        :assetTypes="assetTypes"
        :colorTheme="colorTheme"
        :commoditySpecs="commoditySpecs"
        :componentNumber="1"
        :currencySpecs="currencySpecs"
        :currentLayout="overview_preferences['currentLayout'][0]"
        :etfSpecs="etfSpecs"
        :futuresSpecs="futuresSpecs"
        :indexSpecs="indexSpecs"
        :irSpecs="irSpecs"
        :message0="message0"
        :message1="message1"
        :message2="message2"
        :message3="message3"
        :message4="message4"
        :message5="message5"
        :nSelected="1"
        :overview_preferences="overview_preferences"
        :processData="processData"
        :showLoadingComm="showLoadingComm"
        :showLoadingETF="showLoadingETF"
        :showLoadingFut="showLoadingFut"
        :showLoadingInd="showLoadingInd"
        :showLoadingIR="showLoadingIR"
        :stopAssetType="stopAssetType"
        :TAVisible="TAVisible"
        @emitSpreadTable="emitSpreadTable"
        @eventOnChangeTerm="onChangeTerm"
        @eventOnSelectedAssetType="onSelectedAssetType"
        @eventOnUserAssetSelection="onUserAssetSelection"
        @eventOnUserAssetSelectionList="onUserAssetSelectionList"
        @eventOnUserAsset2Selection="onUserAsset2Selection"
        @eventOnUserClearComponent="onUserClearComponent"
        @eventOnUserSelectVisualization="onUserSelectVisualization"
        @eventOnUserShowFields="onUserShowFields"
        @eventOnUserShowTAChart="onUserShowTAChart"
      />
      <div v-else>Layout not Recognized</div>
    </div>
  </div>
</template>

<script>
import AIChatFloat from "@/components/ai/AIChatFloat.vue";
import Layout1x1 from "@/components/overview/Layout1x1.vue";
import Layout1p2 from "@/components/overview/Layout1p2.vue";
import Layout1x2 from "@/components/overview/Layout1x2.vue";
import Layout1x3 from "@/components/overview/Layout1x3.vue";
import Layout2p1 from "@/components/overview/Layout2p1.vue";
import Layout2x1 from "@/components/overview/Layout2x1.vue";
import Layout2x2 from "@/components/overview/Layout2x2.vue";
import Layout2x3 from "@/components/overview/Layout2x3.vue";
import Navbar from "@/components/Navbar.vue";
import {
  assetTypesConst,
  commoditySpecsConst,
  currencySpecsConst,
  etfSpecsConst,
  futuresSpecsConst,
  indexSpecsConst,
  irSpecsConst,
} from "@/_core/_helpers/_parametric_tools";
import {
  defaultAssets,
  defaultAssetTable,
  defaultBlankRow,
  defaultCurrencies,
  defaultMessage,
  defaultSingleComponents,
  defaultSpotTable,
  defaultSpreadTable,
  initOverviewPreferences,
  layoutOptions,
} from "@/_core/data/Overview.js";
import {
  colorThemeChange,
  colorThemeVuex,
  sortByKey,
  timeParseNoNull2,
} from "@/_core/_helpers/_helpers";
import { getCandleData } from "@/_core/data/api_calls/getCandleData";
import { getCommodityTable } from "@/_core/data/api_calls/getCommodityTable";
import { getConversions } from "@/_core/data/Markets";
import { getETFsTable } from "@/_core/data/api_calls/getETFsTable";
import { getFuturesTable } from "@/_core/data/api_calls/getFuturesTable";
import { getIndexesTable } from "@/_core/data/api_calls/getIndexesTable";
import { getInterestRateTable } from "@/_core/data/api_calls/getInterestRateTable";
import { getSpotData } from "@/_core/data/api_calls/getSpotData";
import { getSpotTable } from "@/_core/data/api_calls/getSpotTable";
import { ProcessData } from "@/_core/data/ProcessData";
import { saveUserPreferences } from "@/_core/data/SaveToDB";
import { selectAll } from "d3";

export default {
  name: "overview",
  components: {
    AIChatFloat,
    Navbar,
    Layout1x1,
    Layout1p2,
    Layout1x2,
    Layout1x3,
    Layout2p1,
    Layout2x1,
    Layout2x2,
    Layout2x3,
  },
  data() {
    return {
      // ======== asset selectors ======================
      assetTypes: assetTypesConst,
      commodityNumber: 3,
      contract: 1,
      currencySpecs: currencySpecsConst,
      commoditySpecs: commoditySpecsConst,
      commodityConversions: [],
      etfSpecs: etfSpecsConst,
      futuresSpecs: futuresSpecsConst,
      indexSpecs: indexSpecsConst,
      irSpecs: irSpecsConst,
      selectedAssetList: { asset: "BRENT", id: 3 },
      showLoadingComm: false,
      showLoadingETF: false,
      showLoadingFut: false,
      showLoadingInd: false,
      showLoadingIR: false,
      stopAssetType: false,
      // ==============================
      allData0: {},
      allData1: {},
      allData2: {},
      allData3: {},
      allData4: {},
      allData5: {},
      listeners: {},
      message0: defaultMessage,
      message1: defaultMessage,
      message2: defaultMessage,
      message3: defaultMessage,
      message4: defaultMessage,
      message5: defaultMessage,
      // ==============================
      defaultCurrencies: defaultCurrencies,
      defaultSpotTable: defaultSpotTable,
      defaultAssets: defaultAssets,
      defaultAssetTable: defaultAssetTable,
      defaultSpreadTable: defaultSpreadTable,
      // ==============================
      colorTheme: true, // true = dark, else light
      defaultSingleComponents: defaultSingleComponents,
      initCommodityDate: new Date(
        new Date().setFullYear(new Date().getFullYear() - 20),
      ),
      initCurrencyDate: new Date(
        new Date().setFullYear(new Date().getFullYear() - 20),
      ),
      layoutOptions: layoutOptions,
      overview_preferences: {},
      processData: null,
      root: document.documentElement,
      user: {},
    };
  },
  created() {
    this.processData = new ProcessData();
    // Process user prefs
    // 1. Get preferences from store (use getter for cleanliness)
    const storePrefs =
      this.$store.getters["user_preferences/overviewChoices"] ||
      this.$store.state.user_preferences?.all?.items?.overview_choices;

    // 2. Validate and correct using initOverviewPreferences
    const { overview_preferences, prefsChanged } = initOverviewPreferences(
      storePrefs,
    );
    // 3. Assign locally
    this.overview_preferences = overview_preferences;
    // 4. Sync news preferences back to Vuex store so child components read them
    if (overview_preferences.news) {
      this.$store.dispatch(
        "user_preferences/updateNewsPreferences",
        overview_preferences.news,
      );
    }
    // process colorTheme
    this.colorTheme =
      this.$store.getters["user_preferences/overviewChoices"]?.color_theme ||
      this.overview_preferences.color_theme;

    if (prefsChanged) {
      colorThemeChange(this.root, this.colorTheme);
      this.onUserColorTheme(this.colorTheme);
    }

    try {
      this.user = this.$store.state.user.all.items;
    } catch (error) {
      console.error(`Error user ${error}`);
    }
    try {
      this.currencySpecs = this.$store.state.currencies.all.items;
    } catch (error) {
      console.error(`Error currencies ${error}`);
    }
    try {
      this.commoditySpecs = this.$store.state.commodities.all.items;
    } catch (error) {
      console.error(`Error commodities ${error}`);
    }
    try {
      this.etfSpecs = this.$store.state.etfs.all.items;
    } catch (error) {
      console.error(`Error etfs ${error}`);
    }
    try {
      this.indexSpecs = this.$store.state.indexes.all.items;
    } catch (error) {
      console.error(`Error indexes ${error}`);
    }
    try {
      this.futuresSpecs = this.$store.state.futures.all.items;
    } catch (error) {
      console.error(`Error futures ${error}`);
    }
    try {
      this.irSpecs = this.$store.state.intRates.all.items;
    } catch (error) {
      console.error(`Error irSpecs ${error}`);
    }

    this.commodityConversions = getConversions();
    this.commodityConversions = this.commodityConversions.map((c) => {
      /**
       * Regex breakdown:
       * ^([\w\s\-\&\.]+):        -> group 1 = commodity (letters, spaces, -, &, .) before colon
       * \s*                      -> optional spaces
       * ([A-Za-z]+)\/([^ \t]+)   -> group 2 = currency1, group 3 = unit1 (anything until whitespace)
       * \s+to\s+                 -> the word 'to' with spaces
       * ([A-Za-z]+)\/([^ \t]+)   -> group 4 = currency2, group 5 = unit2
       */
      const match = c.text.match(
        /^([\w\s\-&.]+):\s*([A-Za-z]+)\/([^ \t]+)\s+to\s+([A-Za-z]+)\/([^ \t]+)/i,
      );
      if (!match) {
        // fallback: try a looser pattern that allows optional colon or different separators
        const looser = c.text.match(
          /^([\w\s-&.]+)[::-]?\s*([A-Za-z]+)\/([^ \t]+).*(?:to|->)\s*([A-Za-z]+)\/([^ \t]+)/i,
        );
        if (!looser) {
          return {
            ...c,
            commodity: "",
            currency1: "",
            unit1: "",
            currency2: "",
            unit2: "",
          };
        }
        return {
          ...c,
          commodity: looser[1].trim(),
          currency1: looser[2].trim(),
          unit1: looser[3].trim(),
          currency2: looser[4].trim(),
          unit2: looser[5].trim(),
        };
      }
      return {
        ...c,
        commodity: match[1].trim(),
        currency1: match[2].trim(),
        unit1: match[3].trim(),
        currency2: match[4].trim(),
        unit2: match[5].trim(),
      };
    });

    document.title = "Overview | Quanspire";
  },
  mounted() {
    this.stopAssetType = true;
    setTimeout(() => {
      this.stopAssetType = false;
    }, 1000);
    // realtime first: a failing panel must not leave the page without sockets
    this._connectIntraday();
    for (const index in this.overview_preferences?.["currentLayout"] ?? []) {
      try {
        this.getDataAPI(+index + 1);
      } catch (error) {
        console.error(`Error getDataAPI ${+index + 1}: ${error}`);
      }
    }
  },
  computed: {
    TAVisible() {
      const firstTA = (
        this?.overview_preferences?.currentLayout ?? []
      ).findIndex((c) => c?.componentId === "technicalChart");
      const availableWindows =
        this?.overview_preferences?.selectedLayout?.windows ?? -1;

      return firstTA === -1 && availableWindows ? firstTA : firstTA + 1;
    },
    listenerKeys() {
      return Object.keys(this.listeners);
    },
  },
  watch: {},
  methods: {
    saveUserPrefs() {
      this.$store.dispatch(
        "user_preferences/updateOverviewChoices",
        this.overview_preferences,
      );
      saveUserPreferences(this);
    },
    allDataField(componentNumber) {
      return "allData" + (componentNumber - 1);
    },
    messageField(componentNumber) {
      return "message" + (componentNumber - 1);
    },
    getDataAPI(componentNumber) {
      let currentLayout = this.overview_preferences["currentLayout"][
        componentNumber - 1
      ];
      let selectedComponent = currentLayout.componentId;

      if (selectedComponent == "technicalChart") {
        this[this.allDataField(componentNumber)] = {
          chartDataRaw: [],
          showLoading: true,
          spot: null,
          spotFactor: null,
          showLoadingSpot: true,
          spotAnimate: null,
        };
        this.getTechAnData(componentNumber);
      } else if (selectedComponent == "commFuturesChart") {
        this.removeListener(componentNumber - 1);
        this.addListener(
          this.commoditySpecs[currentLayout["variables"].selectedAsset]
            .commodity_name,
          componentNumber - 1,
        );
      } else if (selectedComponent === "commodityTable") {
        this[this.allDataField(componentNumber)] = { commodityTable: [] };
        this.removeListener(componentNumber - 1);

        const rawSelectedAssets = currentLayout.variables.selectedAsset;

        const selectedAssetIds = Array.isArray(rawSelectedAssets)
          ? rawSelectedAssets
          : rawSelectedAssets
              .toString()
              .split(",")
              .map(Number)
              .filter((id) => !Number.isNaN(id));

        this.commoditySpecs.forEach((spec) => {
          if (selectedAssetIds.includes(spec.pk_idcommodity)) {
            this.addListener(spec.commodity_name, componentNumber - 1);
          }
        });

        const filteredAssets = this.commoditySpecs
          .filter((d) => selectedAssetIds?.includes(d.pk_idcommodity))
          .map((d) => d.pk_idcommodity);

        const assetParams =
          filteredAssets.length > 0
            ? filteredAssets.join(",")
            : this.selectedAssetList.id;

        getCommodityTable(assetParams).then((data) => {
          this.parseCommTable(data, componentNumber);
        });
      } else if (selectedComponent == "commoditySpread") {
        this.$set(
          this[this.allDataField(componentNumber)],
          "spreadTable",
          JSON.parse(JSON.stringify(defaultSpreadTable)),
        );
        this.removeListener(componentNumber - 1);
        const comm1 = this.commoditySpecs[
          currentLayout["variables"].selectedAsset
        ];
        const comm2 = this.commoditySpecs[
          currentLayout["variables"].selectedAsset2
        ];
        this.$set(
          this[this.allDataField(componentNumber)]["spreadTable"][0],
          "name",
          comm1.commodity_name,
        );
        this.$set(
          this[this.allDataField(componentNumber)]["spreadTable"][1],
          "name",
          comm2.commodity_name,
        );
        this.addListener(comm1.commodity_name, componentNumber - 1);
        this.addListener(comm2.commodity_name, componentNumber - 1);
        getCommodityTable(comm1.pk_idcommodity).then((data) => {
          data = data[0].futures_data;
          this.parseSpreadTable(data, componentNumber, 0, comm1.commodity_name);
          this.finishParseSpreadTable(componentNumber);
        });
        getCommodityTable(comm2.pk_idcommodity).then((data) => {
          data = data[0].futures_data;
          this.parseSpreadTable(data, componentNumber, 1, comm2.commodity_name);
          this.finishParseSpreadTable(componentNumber);
        });

        const targetUnit1 = comm1.fk_idunit;
        const targetUnit2 = comm2.fk_idunit;
        const targetCmdty = comm2.commodity_name;
        let conversion = 1;
        if (targetUnit1 != targetUnit2) {
          conversion =
            this.commodityConversions.find(
              (c) =>
                c.commodity == targetCmdty &&
                c.unit1 === targetUnit2 &&
                c.unit2 === targetUnit1,
            )?.value ?? 0;
        }
        this.$set(
          this[this.allDataField(componentNumber)]["spreadTable"][3]["data"],
          "conversion",
          conversion,
        );
        let targetCurr1 = comm1.fk_idcurrency;
        let targetCurr2 = comm2.fk_idcurrency;
        const pair1 = `${targetCurr1}${targetCurr2}`;
        const pair2 = `${targetCurr2}${targetCurr1}`;
        let foundPair = this.currencySpecs.find(
          (c) => c.currency_name === pair1 || c.currency_name === pair2,
        );
        targetCurr1 = comm1.is_cents
          ? targetCurr1.replace("USD", "USc")
          : targetCurr1;
        targetCurr2 = comm2.is_cents
          ? targetCurr2.replace("USD", "USc")
          : targetCurr2;
        this.$set(
          this[this.allDataField(componentNumber)]["spreadTable"][3],
          "name",
          [
            targetCurr1,
            targetCurr2,
            targetUnit1,
            targetUnit2,
            foundPair?.currency_name ?? null,
          ],
        );
        if (!foundPair) {
          // console.warn("No currency pair found for", pair1, "or", pair2);
          this.$set(
            this[this.allDataField(componentNumber)]["spreadTable"][3]["data"],
            "rate",
            1,
          );
        } else {
          let _this = this;
          getSpotTable([foundPair.currency_name]).then((data) => {
            _this.$set(
              _this[_this.allDataField(componentNumber)]["spreadTable"][3][
                "data"
              ],
              "rate",
              data[0].close,
            );
            _this.finishParseSpreadTable(componentNumber);
          });
          this.addListener(foundPair.currency_name, componentNumber - 1);
        }
      } else if (selectedComponent == "currencySpotTable") {
        this[this.allDataField(componentNumber)] = {
          spotTable: this.defaultSpotTable,
        };
        let currs = [].concat(...this.defaultCurrencies.map((d) => d.assets));
        getSpotTable(currs).then((data) => {
          this.parseSpotCurrTable(data, componentNumber, 0);
        });
        this.removeListener(componentNumber - 1);
        for (const curr of currs) {
          this.addListener(curr, componentNumber - 1);
        }
      } else if (selectedComponent == "assetsTable") {
        this[this.allDataField(componentNumber)] = {
          spotTable: this.defaultAssetTable,
        };
        let assets = this.defaultAssets[0]["assets"];
        getInterestRateTable(assets).then((data) => {
          this.parseAssetTable(data, componentNumber, 0, 2);
        });
        assets = this.defaultAssets[1]["assets"];
        getIndexesTable(assets).then((data) => {
          this.parseAssetTable(data, componentNumber, 1, 3);
        });
        assets = this.defaultAssets[2]["assets"];
        getETFsTable(assets).then((data) => {
          this.parseAssetTable(data, componentNumber, 2, 5);
        });
        assets = this.defaultAssets[3]["assets"];
        getFuturesTable(assets).then((data) => {
          this.parseAssetTable(data, componentNumber, 3, 4);
        });
        this.removeListener(componentNumber - 1);
        for (const asset of assets) {
          this.addListener(asset, componentNumber - 1);
        }
      }
      // else if (selectedComponent == "currencyForward") {
      // }
      else if (selectedComponent == "newsWidget") {
        this[this.allDataField(componentNumber)] = {};
      }
      this.saveUserPrefs();
    },
    finishParseSpreadTable(componentNumber) {
      let table1 = this[this.allDataField(componentNumber)]["spreadTable"][0][
        "data"
      ];
      let table2 = this[this.allDataField(componentNumber)]["spreadTable"][1][
        "data"
      ];
      if (table1.length == 0 || table2.length == 0) {
        return;
      }
      // sort correctly
      const monthOrder = [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ];
      const parseMonthYear = (str) => {
        const month = str.slice(0, 3);
        const year = parseInt("20" + str.slice(3)); // "JAN25" → "2025"
        return { month, year };
      };
      // sorted with all contracts
      const allMonths = Array.from(
        new Set([
          ...table1.map((d) => d.contract_month_year),
          ...table2.map((d) => d.contract_month_year),
        ]),
      ).sort((a, b) => {
        const A = parseMonthYear(a);
        const B = parseMonthYear(b);
        if (A.year !== B.year) return A.year - B.year;
        return monthOrder.indexOf(A.month) - monthOrder.indexOf(B.month);
      });
      const blankRow = defaultBlankRow;
      const aligned1 = this.alignTableNext(table1, allMonths, blankRow);
      const aligned2 = this.alignTableNext(table2, allMonths, blankRow);
      this.$set(
        this[this.allDataField(componentNumber)]["spreadTable"][0],
        "data",
        aligned1,
      );
      this.$set(
        this[this.allDataField(componentNumber)]["spreadTable"][1],
        "data",
        aligned2,
      );
      let constants = this[this.allDataField(componentNumber)][
        "spreadTable"
      ][3]["data"];
      if (constants.conversion == null || constants.rate == null) {
        return;
      }
      let switchTable = this.buildSpreads(aligned1, aligned2, constants);
      this.$set(
        this[this.allDataField(componentNumber)]["spreadTable"][2],
        "data",
        switchTable,
      );
    },
    buildSpreads(alignedTable1, alignedTable2, constants) {
      if (
        !Array.isArray(alignedTable1) ||
        !alignedTable1[0]?.contract_month_year ||
        !Array.isArray(alignedTable2) ||
        !alignedTable2[0]?.close ||
        !alignedTable1[0]?.close
      ) {
        return []; // Exit early with empty array
      }
      let cnst = constants.conversion * constants.rate;

      const result = [];

      for (let i = 0; i < alignedTable1.length; i++) {
        const current1 = alignedTable1[i];
        const current2 = alignedTable2[i];

        // Si cualquiera de los dos 'close' es null, los valores derivados serán null
        const invalid = current1.close == null || current2.close == null;

        if (i === 0) {
          result.push({
            contract_month_year: current1.contract_month_year,
            switch1: "-.-",
            arb1: invalid ? null : current1.close - cnst * current2.close,
            close1: null,
            switch2: "-.-",
            arb2: invalid ? null : current1.close / cnst - current2.close,
            close2: null,
          });
        } else {
          const prev1 = alignedTable1[i - 1];
          const prev2 = alignedTable2[i - 1];

          const diff1 =
            prev1.close == null || current1.close == null
              ? null
              : +prev1.close - +current1.close;
          const diff2 =
            prev2.close == null || current2.close == null
              ? null
              : +prev2.close - +current2.close;

          const invalidPair =
            current1.close == null ||
            current2.close == null ||
            diff1 == null ||
            diff2 == null;

          result.push({
            contract_month_year: current1.contract_month_year,
            switch1: `${prev1.contract_month_year} / ${current1.contract_month_year}`,
            arb1: invalidPair ? null : +current1.close - cnst * +current2.close,
            close1: diff1,
            switch2: `${prev2.contract_month_year} / ${current2.contract_month_year}`,
            arb2: invalidPair ? null : +current1.close / cnst - +current2.close,
            close2: diff2,
          });
        }
      }
      return result;
    },
    alignTableNext(table, allMonths, blankRow) {
      // alignTableNext: fill missing months using the next available close (i.e. look-ahead fill)
      // defensive: ensure inputs are arrays
      if (!Array.isArray(table) || !Array.isArray(allMonths)) return [];
      // 1) Build a lookup map for fast finds. Normalize keys by trimming.
      const rowMap = new Map(
        table.map((r) => [String(r.contract_month_year).trim(), { ...r }]), // shallow clone to avoid mutating original
      );
      const result = [];
      let nextClose = null; // will hold the next available close when iterating backwards
      // 2) Iterate backward through allMonths and unshift rows (so final order is same as allMonths)
      for (let i = allMonths.length - 1; i >= 0; i--) {
        const rawMonth = allMonths[i];
        const monthKey = String(rawMonth).trim();
        if (rowMap.has(monthKey)) {
          // existing row: push a clone (so we don't mutate original objects)
          const existing = { ...rowMap.get(monthKey) };
          result.unshift(existing);
          // normalize numeric close: keep as-is if null/undefined, otherwise numeric/string allowed
          nextClose = existing.close !== undefined ? existing.close : null;
        } else {
          // missing row: fill with nextClose (could be null if no next available)
          result.unshift(blankRow(monthKey, nextClose));
        }
      }
      return result;
    },
    getTechAnData(componentNumber) {
      let _this = this;
      const finishParse = function(data) {
        return {
          chartDataRaw: data,
          spot: data[data.length - 1].close,
          showLoading: false,
          spotFactor: null,
          showLoadingSpot: false,
          spotAnimate: null,
        };
      };
      let selectedAssetType = this.overview_preferences["currentLayout"][
        componentNumber - 1
      ]["variables"].assetType;
      let selectedAsset = this.overview_preferences["currentLayout"][
        componentNumber - 1
      ]["variables"].selectedAsset;
      let result = {
        chartDataRaw: [],
        showLoading: true,
        spot: null,
        spotFactor: null,
        showLoadingSpot: false,
        spotAnimate: null,
      };

      if (selectedAssetType === 0) {
        // 0: CURRENCY
        if (typeof selectedAsset === "string") {
          const index = this.currencySpecs.findIndex(
            (c) => c.currency_name === selectedAsset,
          );
          selectedAsset = Math.max(1, index);
          Object.assign(
            this.overview_preferences["currentLayout"][componentNumber - 1][
              "variables"
            ],
            {
              selectedAsset: selectedAsset,
            },
          );
        }
        this.removeListener(componentNumber - 1);
        this.addListener(
          this.currencySpecs[selectedAsset].currency_name,
          componentNumber - 1,
        );
        let currencyNumber = this.currencySpecs[selectedAsset].pk_i_idcurrency;
        let currString = this.currencySpecs[selectedAsset].currency_name;
        getCandleData(this, "currency", { currencyNumber: currencyNumber })
          .then((data) => {
            result = finishParse(data);
            this[this.allDataField(componentNumber)] = result;
            getSpotData(
              this,
              "spot",
              "updatedAt",
              "showLoadingSpot",
              "currency",
              null,
              false,
              currencyNumber,
              currString,
            )
              .then((data) => {
                const lastElement = this[this.allDataField(componentNumber)]
                  .chartDataRaw[
                  this[this.allDataField(componentNumber)].chartDataRaw.length -
                    1
                ];
                const lastDate = timeParseNoNull2(lastElement.observation_date);
                const newDate = timeParseNoNull2(data[0].observation_date);
                if (lastDate.getTime() === newDate.getTime()) {
                  // Reemplazar valores del último elemento
                  this[this.allDataField(componentNumber)].chartDataRaw[
                    this[this.allDataField(componentNumber)].chartDataRaw
                      .length - 1
                  ].open = data[0].open;
                  this[this.allDataField(componentNumber)].chartDataRaw[
                    this[this.allDataField(componentNumber)].chartDataRaw
                      .length - 1
                  ].high = data[0].high;
                  this[this.allDataField(componentNumber)].chartDataRaw[
                    this[this.allDataField(componentNumber)].chartDataRaw
                      .length - 1
                  ].low = data[0].low;
                  this[this.allDataField(componentNumber)].chartDataRaw[
                    this[this.allDataField(componentNumber)].chartDataRaw
                      .length - 1
                  ].close = data[0].close;
                } else if (newDate > lastDate) {
                  // La fecha es mayor, agregar nuevo elemento
                  this[this.allDataField(componentNumber)].chartDataRaw.push({
                    date: newDate,
                    close: data[0].close,
                    open: data[0].open,
                    high: data[0].high,
                    low: data[0].low,
                  });
                }
                this[this.allDataField(componentNumber)].spot = data[0].close;
              })
              .catch(function(error) {
                console.error(error);
              });
          })
          .catch(function(error) {
            _this[_this.allDataField(componentNumber)]["showLoading"] = false;
            _this[_this.allDataField(componentNumber)]["chartDataRaw"] = [];
            console.error(error);
          });
      } else if (selectedAssetType === 1) {
        // 1: COMMODITY
        if (typeof selectedAsset === "string") {
          const index = this.commoditySpecs.findIndex(
            (c) => c.commodity_name === selectedAsset,
          );
          selectedAsset = Math.max(1, index);
          Object.assign(
            this.overview_preferences["currentLayout"][componentNumber - 1][
              "variables"
            ],
            {
              selectedAsset: selectedAsset,
            },
          );
        }
        this.removeListener(componentNumber - 1);
        this.addListener(
          this.commoditySpecs[selectedAsset].commodity_name,
          componentNumber - 1,
        );
        let commodityNumber = this.commoditySpecs[selectedAsset].pk_idcommodity;
        this.commodityNumber = commodityNumber; // update for use in other methods
        const continuous_contract =
          this?.overview_preferences?.currentLayout?.[componentNumber - 1]
            ?.variables?.continuous_contract ?? null;
        const candleField =
          continuous_contract == null ? "commodity" : "commodity_contract";
        let contract =
          continuous_contract == null
            ? this.commoditySpecs[selectedAsset].selected_contract
            : continuous_contract;
        this.contract = contract; // update for use in other methods
        getCandleData(this, candleField, {
          commodityNumber: commodityNumber,
          contract: contract,
        })
          .then((data) => {
            result = finishParse(data);
            this[this.allDataField(componentNumber)] = result;
            getSpotData(
              this,
              "spot",
              "updatedAt",
              "showLoadingSpot",
              "commodity",
            )
              .then((data) => {
                const lastElement = this[this.allDataField(componentNumber)]
                  .chartDataRaw[
                  this[this.allDataField(componentNumber)].chartDataRaw.length -
                    1
                ];
                const lastDate = timeParseNoNull2(lastElement.observation_date);
                const newDate = timeParseNoNull2(data[0].observation_date);
                if (lastDate.getTime() === newDate.getTime()) {
                  // Reemplazar valores del último elemento
                  this[this.allDataField(componentNumber)].chartDataRaw[
                    this[this.allDataField(componentNumber)].chartDataRaw
                      .length - 1
                  ].open = data[0].open;
                  this[this.allDataField(componentNumber)].chartDataRaw[
                    this[this.allDataField(componentNumber)].chartDataRaw
                      .length - 1
                  ].high = data[0].high;
                  this[this.allDataField(componentNumber)].chartDataRaw[
                    this[this.allDataField(componentNumber)].chartDataRaw
                      .length - 1
                  ].low = data[0].low;
                  this[this.allDataField(componentNumber)].chartDataRaw[
                    this[this.allDataField(componentNumber)].chartDataRaw
                      .length - 1
                  ].close = data[0].last_price;
                } else if (newDate > lastDate) {
                  // La fecha es mayor, agregar nuevo elemento
                  this[this.allDataField(componentNumber)].chartDataRaw.push({
                    date: newDate,
                    close: data[0].last_price,
                    open: data[0].open,
                    high: data[0].high,
                    low: data[0].low,
                  });
                }
                this[this.allDataField(componentNumber)].spot =
                  data[0].last_price;
              })
              .catch(function(error) {
                console.error(error);
              });
          })
          .catch(function(error) {
            _this[_this.allDataField(componentNumber)]["showLoading"] = false;
            _this[_this.allDataField(componentNumber)]["chartDataRaw"] = [];
            console.error(error);
          });
      } else if (selectedAssetType === 2) {
        // 2: INTEREST RATE
        if (typeof selectedAsset === "string") {
          const index = this.irSpecs.findIndex(
            (c) => c.interest_rate_name === selectedAsset,
          );
          selectedAsset = Math.max(1, index);
          Object.assign(
            this.overview_preferences["currentLayout"][componentNumber - 1][
              "variables"
            ],
            {
              selectedAsset: selectedAsset,
            },
          );
        }
        this.removeListener(componentNumber - 1);
        this.addListener(
          this.irSpecs[selectedAsset].interest_rate_name,
          componentNumber - 1,
        );

        let irHistAllTerms = [];
        let irAvailableTerms = [];
        let irSelectedTerm = null;
        let interest_rate = this.irSpecs[selectedAsset].pk_idinterestrate;
        getCandleData(this, "interest_rate", {
          interest_rate: interest_rate,
          initDate: this.initCurrencyDate,
        })
          .then((data) => {
            irHistAllTerms = [...data];
            irAvailableTerms = Array.from(
              new Set(
                data.map((item) => item.term).filter((term) => term != null),
              ),
              (term) => ({ label: term, value: term }),
            );
            this.overview_preferences["currentLayout"][componentNumber - 1][
              "variables"
            ]["irAvailableTerms"] = irAvailableTerms;
            if (irAvailableTerms.some((d) => d.value === "3M")) {
              irSelectedTerm = "3M";
            } else if (irAvailableTerms.some((d) => d.value === "10Y")) {
              irSelectedTerm = "10Y";
            } else {
              irSelectedTerm = irAvailableTerms[0]?.value;
            }

            let filteredData = irHistAllTerms;
            if (irAvailableTerms.length > 1) {
              filteredData = irHistAllTerms.filter(
                (d) => d.term === irSelectedTerm,
              );
            }
            result = finishParse(filteredData);
            result["irHistAllTerms"] = irHistAllTerms;
            this.overview_preferences["currentLayout"][componentNumber - 1][
              "variables"
            ]["selectedTerm"] = irSelectedTerm;
            this[this.allDataField(componentNumber)] = result;
          })
          .catch(function(error) {
            _this[_this.allDataField(componentNumber)]["showLoading"] = false;
            _this[_this.allDataField(componentNumber)]["chartDataRaw"] = [];
            console.error(error);
          });
      } else if (selectedAssetType === 3) {
        // 3: INDEX
        if (typeof selectedAsset === "string") {
          const index = this.indexSpecs.findIndex(
            (c) => c.short_name === selectedAsset,
          );
          selectedAsset = Math.max(1, index);
          Object.assign(
            this.overview_preferences["currentLayout"][componentNumber - 1][
              "variables"
            ],
            {
              selectedAsset: selectedAsset,
            },
          );
        }
        this.removeListener(componentNumber - 1);
        this.addListener(
          this.indexSpecs[selectedAsset].short_name,
          componentNumber - 1,
        );

        let indexNumber = this.indexSpecs[selectedAsset].pk_i_idindexes;
        getCandleData(this, "index", {
          index: indexNumber,
          initDate: this.initCurrencyDate,
        })
          .then((data) => {
            result = finishParse(data);
            this[this.allDataField(componentNumber)] = result;
          })
          .catch(function(error) {
            _this[_this.allDataField(componentNumber)]["showLoading"] = false;
            _this[_this.allDataField(componentNumber)]["chartDataRaw"] = [];
            console.error(error);
          });
      } else if (selectedAssetType === 4) {
        // 4: FUTURES
        if (typeof selectedAsset === "string") {
          const index = this.futuresSpecs.findIndex(
            (c) => c.short_name === selectedAsset,
          );
          selectedAsset = Math.max(1, index);
          Object.assign(
            this.overview_preferences["currentLayout"][componentNumber - 1][
              "variables"
            ],
            {
              selectedAsset: selectedAsset,
            },
          );
        }
        this.removeListener(componentNumber - 1);
        this.addListener(
          this.futuresSpecs[selectedAsset].short_name,
          componentNumber - 1,
        );

        let futNumber = this.futuresSpecs[selectedAsset].pk_i_idfutures;
        getCandleData(this, "futures", {
          futures: futNumber,
          initDate: this.initCurrencyDate,
        })
          .then((data) => {
            result = finishParse(data);
            this[this.allDataField(componentNumber)] = result;
          })
          .catch(function(error) {
            _this[_this.allDataField(componentNumber)]["showLoading"] = false;
            _this[_this.allDataField(componentNumber)]["chartDataRaw"] = [];
            console.error(error);
          });
      } else if (selectedAssetType === 5) {
        // 5: ETF
        if (typeof selectedAsset === "string") {
          const index = this.etfSpecs.findIndex(
            (c) => c.short_name === selectedAsset,
          );
          selectedAsset = Math.max(1, index);
          Object.assign(
            this.overview_preferences["currentLayout"][componentNumber - 1][
              "variables"
            ],
            {
              selectedAsset: selectedAsset,
            },
          );
        }
        this.removeListener(componentNumber - 1);
        this.addListener(
          this.etfSpecs[selectedAsset].short_name,
          componentNumber - 1,
        );

        let etfNumber = this.etfSpecs[selectedAsset].pk_i_idetf;
        getCandleData(this, "etfs", {
          etfs: etfNumber,
          initDate: this.initCurrencyDate,
        })
          .then((data) => {
            result = finishParse(data);
            this[this.allDataField(componentNumber)] = result;
          })
          .catch(function(error) {
            _this[_this.allDataField(componentNumber)]["showLoading"] = false;
            _this[_this.allDataField(componentNumber)]["chartDataRaw"] = [];
            console.error(error);
          });
      }
    },
    parseAssetTable(data, componentNumber, tableIndex, assetType) {
      data = JSON.parse(JSON.stringify(data));
      data.forEach(function(d) {
        d.assetType = assetType;
        d.last_trading_date = timeParseNoNull2(d.last_trading_date);
        d.observation_date = timeParseNoNull2(d.observation_date);
        d.prev_close = +d.prev_close;
        d.prev_close_5d = +d.prev_close_5d;
        d.prev_close_10d = +d.prev_close_10d;
        d.prev_close_20d = +d.prev_close_20d;
        if (!d.prev_close) d.prev_close = d.close;
        if (!d.prev_close_5d) d.prev_close_5d = d.close;
        if (!d.prev_close_10d) d.prev_close_10d = d.close;
        if (!d.prev_close_20d) d.prev_close_20d = d.close;
        d.change = d.close - d.prev_close;
        d.pct_change = d.change / d.prev_close;
        d.pct_change_5 = (d.close - d.prev_close_5d) / d.prev_close_5d;
        d.pct_change_10 = (d.close - d.prev_close_10d) / d.prev_close_10d;
        d.pct_change_20 = (d.close - d.prev_close_20d) / d.prev_close_20d;
      });
      this.$set(
        this[this.allDataField(componentNumber)]["spotTable"][tableIndex],
        "data",
        data,
      );
    },
    parseSpotCurrTable(data, componentNumber, assetType = 0) {
      data = JSON.parse(JSON.stringify(data));
      data.forEach(function(d) {
        d.assetType = assetType;
        d.last_trading_date = timeParseNoNull2(d.last_trading_date);
        d.observation_date = timeParseNoNull2(d.observation_date);
        d.prev_close = +d.prev_close;
        d.prev_close_5d = +d.prev_close_5d;
        d.prev_close_10d = +d.prev_close_10d;
        d.prev_close_20d = +d.prev_close_20d;
        if (!d.prev_close) d.prev_close = d.close;
        if (!d.prev_close_5d) d.prev_close_5d = d.close;
        if (!d.prev_close_10d) d.prev_close_10d = d.close;
        if (!d.prev_close_20d) d.prev_close_20d = d.close;
        d.change = d.close - d.prev_close;
        d.pct_change = d.change / d.prev_close;
        d.pct_change_5 = (d.close - d.prev_close_5d) / d.prev_close_5d;
        d.pct_change_10 = (d.close - d.prev_close_10d) / d.prev_close_10d;
        d.pct_change_20 = (d.close - d.prev_close_20d) / d.prev_close_20d;
      });
      const grouped = this.defaultCurrencies.map((cat) => ({
        name: cat.name,
        data: data.filter((d) => cat.assets.includes(d.asset)),
      }));
      this[this.allDataField(componentNumber)] = { spotTable: grouped };
    },
    parseSpreadTable(data, componentNumber, tableIndex, asset) {
      data = JSON.parse(JSON.stringify(data));
      data.forEach(function(d) {
        d.assetType = 1;
        d.asset = asset;
        d.last_trading_date = timeParseNoNull2(d.last_trading_date);
        d.observation_date = timeParseNoNull2(d.observation_date);
        d.prev_close = +d.prev_close;
        if (!d.prev_close) {
          d.prev_close = d.close;
        }
        d.change = d.close - d.prev_close;
        d.pct_change = d.change / d.prev_close;
      });
      data.filter((value, index, self) => {
        return (
          self.findIndex(
            (v) => v.contract_month_year === value.contract_month_year,
          ) === index
        );
      });
      data = sortByKey(data, "last_trading_date");
      this.$set(
        this[this.allDataField(componentNumber)]["spreadTable"][tableIndex],
        "data",
        data,
      );
    },
    parseCommTable(data, componentNumber) {
      let allParsedData = [];

      data.forEach((commodityData) => {
        const commodityId = commodityData.commodity_id;
        const futuresData = commodityData.futures_data;

        const comm = this.commoditySpecs.find(
          (c) => c.pk_idcommodity === commodityId,
        );

        const targetUnit1 = "mt";
        const targetUnit2 = comm.fk_idunit;
        const targetCmdty = comm.commodity_name;
        let conversion = null;

        if (targetUnit1 != targetUnit2) {
          conversion =
            this.commodityConversions.find(
              (c) =>
                c.commodity == targetCmdty &&
                c.unit1 === targetUnit2 &&
                c.unit2 === targetUnit1,
            )?.value ?? 0;
        }

        const parsedFuturesData = JSON.parse(JSON.stringify(futuresData));
        if (parsedFuturesData.length > 0) {
          parsedFuturesData.unshift({ ...parsedFuturesData[0] });
        }
        parsedFuturesData.forEach(function(d, i) {
          d.pk_idcommodity = commodityId;
          d.assetType = 1;
          d.asset = comm.commodity_name;
          d.contract_month_year = i == 0 ? "1st" : d.contract_month_year;
          d.commodity_name = comm.commodity_name;
          d.last_trading_date = timeParseNoNull2(d.last_trading_date);
          d.observation_date = timeParseNoNull2(d.observation_date);
          d.prev_close = +d.prev_close;
          if (!d.prev_close) {
            d.prev_close = d.close;
          }
          d.prev_close_5d = +d.prev_close_5d;
          d.prev_close_10d = +d.prev_close_10d;
          d.prev_close_20d = +d.prev_close_20d;
          if (!d.prev_close) d.prev_close = d.close;
          if (!d.prev_close_5d) d.prev_close_5d = d.close;
          if (!d.prev_close_10d) d.prev_close_10d = d.close;
          if (!d.prev_close_20d) d.prev_close_20d = d.close;
          d.change = d.close - d.prev_close;
          d.pct_change = d.change / d.prev_close;
          d.pct_change_5 = (d.close - d.prev_close_5d) / d.prev_close_5d;
          d.pct_change_10 = (d.close - d.prev_close_10d) / d.prev_close_10d;
          d.pct_change_20 = (d.close - d.prev_close_20d) / d.prev_close_20d;
          d.conversion = conversion;
          d.converted_close = d.close * conversion;
        });
        allParsedData.push(...parsedFuturesData);
      });

      this[this.allDataField(componentNumber)] = {
        commodityTable: allParsedData,
      };
    },
    onUserColorTheme(val) {
      this.colorTheme = val;
      this.overview_preferences.color_theme = val;
      colorThemeVuex(this, this.colorTheme);
      saveUserPreferences(this);
    },
    onUserSelectLayout(valueString) {
      Object.assign(this.overview_preferences, {
        selectedLayout: this.layoutOptions.find(
          (opt) => opt.value === valueString,
        ),
      });
    },
    removeListener(valueToRemove) {
      let obj = this.listeners;
      for (const key in obj) {
        // filter array and delete value
        obj[key] = obj[key].filter((v) => v !== valueToRemove);
        // if empty, delete listener's key
        if (obj[key].length === 0) {
          delete obj[key];
        }
      }
      this.listeners = JSON.parse(JSON.stringify(obj));
    },
    addListener(key, value) {
      let obj = this.listeners;
      if (!obj[key]) {
        obj[key] = [value];
      } else if (!obj[key].includes(value)) {
        obj[key].push(value);
      }
      this.listeners = JSON.parse(JSON.stringify(obj));
    },
    onUserClearComponent(value) {
      Object.assign(this.overview_preferences["currentLayout"][value - 1], {
        componentId: null,
        variables: {},
      });
      this[this.messageField(value)]["close"] = null;
      this[this.messageField(value)] = defaultMessage;
      this.removeListener(value - 1);
    },
    onUserSelectVisualization(component) {
      this[this.messageField(component.componentNumber)]["close"] = null;
      this[this.messageField(component.componentNumber)] = defaultMessage;
      let dflt = this.defaultSingleComponents(component.id);
      Object.assign(
        this.overview_preferences["currentLayout"][
          component.componentNumber - 1
        ],
        { componentId: dflt.componentId, variables: dflt.variables },
      );
      this.getDataAPI(component.componentNumber);
    },
    onUserShowFields(component) {
      this.overview_preferences["currentLayout"][component - 1]["variables"][
        "showFields"
      ] = !this.overview_preferences["currentLayout"][component - 1][
        "variables"
      ]["showFields"];
    },
    onUserShowTAChart(asset) {
      this.stopAssetType = true;
      setTimeout(() => {
        this.stopAssetType = false;
      }, 1000);
      let {
        assetType,
        irAvailableTerms,
        selectedAsset,
        selectedTerm,
        continuous_contract,
        showFields,
        componentNumber,
      } = asset;
      const currentLayout = this.overview_preferences["currentLayout"][
        componentNumber - 1
      ];
      if (selectedAsset == null) {
        selectedAsset = currentLayout["variables"]["selectedAsset"];
      }
      this[this.messageField(this.TAVisible)]["close"] = null;
      this[this.messageField(this.TAVisible)] = defaultMessage;

      Object.assign(
        this.overview_preferences["currentLayout"][this.TAVisible - 1][
          "variables"
        ],
        {
          assetType: assetType,
          continuous_contract: continuous_contract,
          irAvailableTerms: irAvailableTerms,
          selectedAsset: selectedAsset,
          selectedTerm: selectedTerm,
          showFields: showFields,
        },
      );
      this[this.messageField(this.TAVisible)]["close"] = null;
      this[this.messageField(this.TAVisible)] = defaultMessage;
      this.getDataAPI(this.TAVisible);
    },
    onSelectedAssetType(val) {
      let variables = {};
      if (this.stopAssetType) {
        const currentLayout = this.overview_preferences["currentLayout"][
          val.componentNumber - 1
        ];
        const selectedAsset = currentLayout["variables"]["selectedAsset"];
        const selectedTerm = currentLayout["variables"]["selectedTerm"];
        variables = {
          assetType: val.assetType,
          selectedAsset: selectedAsset,
          irAvailableTerms: [{ label: "...", value: "..." }],
          selectedTerm: selectedTerm,
        };
      } else {
        variables = {
          assetType: val.assetType,
          selectedAsset: null,
          irAvailableTerms: [{ label: "...", value: "..." }],
          selectedTerm: null,
        };
      }
      Object.assign(
        this.overview_preferences["currentLayout"][val.componentNumber - 1][
          "variables"
        ],
        variables,
      );
      this[this.messageField(val.componentNumber)]["close"] = null;
      this[this.messageField(val.componentNumber)] = defaultMessage;
    },
    onUserAssetSelection(val) {
      Object.assign(
        this.overview_preferences["currentLayout"][val.componentNumber - 1][
          "variables"
        ],
        { selectedAsset: val.selectedAsset },
      );
      this[this.messageField(val.componentNumber)]["close"] = null;
      this[this.messageField(val.componentNumber)] = defaultMessage;
      this.getDataAPI(val.componentNumber);
    },
    onUserAssetSelectionList(val) {
      Object.assign(
        this.overview_preferences["currentLayout"][val.componentNumber - 1][
          "variables"
        ],
        { selectedAsset: val.selectedAssets },
      );
      this[this.messageField(val.componentNumber)]["close"] = null;
      this[this.messageField(val.componentNumber)] = defaultMessage;
      this.getDataAPI(val.componentNumber);
    },
    onUserAsset2Selection(val) {
      Object.assign(
        this.overview_preferences["currentLayout"][val.componentNumber - 1][
          "variables"
        ],
        { selectedAsset2: val.selectedAsset },
      );
      this[this.messageField(val.componentNumber)]["close"] = null;
      this[this.messageField(val.componentNumber)] = defaultMessage;
      this.getDataAPI(val.componentNumber);
    },
    emitSpreadTable(val) {
      let switchTable = this.buildSpreads(
        val.alignedTable1,
        val.alignedTable2,
        val.constants,
      );
      this.$set(
        this[this.allDataField(val.componentNumber)]["spreadTable"][2],
        "data",
        switchTable,
      );
    },
    onChangeTerm(val) {
      this[this.messageField(val.componentNumber)]["close"] = null;
      this[this.messageField(val.componentNumber)] = defaultMessage;
      Object.assign(
        this.overview_preferences["currentLayout"][val.componentNumber - 1][
          "variables"
        ],
        { selectedTerm: val.irSelectedTerm },
      );
      let irHistAllTerms = this[this.allDataField(val.componentNumber)][
        "irHistAllTerms"
      ];
      let irAvailableTerms = this.overview_preferences["currentLayout"][
        val.componentNumber - 1
      ]["variables"]["irAvailableTerms"];
      let filteredData = irHistAllTerms;
      if (irAvailableTerms.length > 1) {
        filteredData = irHistAllTerms.filter(
          (d) => d.term === val.irSelectedTerm,
        );
      }
      this[this.allDataField(val.componentNumber)][
        "chartDataRaw"
      ] = filteredData;
    },
    _connectIntraday() {
      const base = (process.env.VUE_APP_GATEWAY_URL || "")
        .replace(/\/$/, "")
        .replace(/^http/, "ws");
      const channels = ["forex", "fxmkt_intraday", "cme", "yahoo_intraday"];
      this._wsSockets = {};
      this._wsRetries = {};
      this._wsTimers = {};
      channels.forEach((channel) => this._openIntradaySocket(base, channel));
    },
    _openIntradaySocket(base, channel) {
      const socket = new WebSocket(`${base}/ws/${channel}`);
      socket.onopen = () => {
        this._wsRetries[channel] = 0;
      };
      socket.onmessage = ({ data }) => {
        try {
          this._handleIntradayMessage(channel, JSON.parse(data));
        } catch (error) {
          console.error(`[WS] ${channel} message error`, error);
        }
      };
      socket.onerror = (err) => console.warn(`[WS] ${channel}`, err);
      socket.onclose = () => {
        // stopped on purpose (page left) or replaced by a newer socket
        if (!this._wsSockets || this._wsSockets[channel] !== socket) {
          return;
        }
        const retries = this._wsRetries[channel] || 0;
        const delay = Math.min(30000, 1000 * 2 ** retries);
        this._wsRetries[channel] = retries + 1;
        console.warn(`[WS] ${channel} closed, reconnecting in ${delay} ms`);
        this._wsTimers[channel] = setTimeout(() => {
          if (this._wsSockets) {
            this._openIntradaySocket(base, channel);
          }
        }, delay);
      };
      this._wsSockets[channel] = socket;
    },
    _disconnectIntraday() {
      if (this._wsTimers) {
        Object.values(this._wsTimers).forEach((t) => clearTimeout(t));
        this._wsTimers = null;
      }
      if (this._wsSockets) {
        const sockets = Object.values(this._wsSockets);
        this._wsSockets = null;
        sockets.forEach((s) => s.close());
      }
    },
    _handleIntradayMessage(channel, data) {
      let msg;
      if (channel === "forex") {
        msg = {
          change: null,
          close: data.close,
          continuous_contract: null,
          contract: data.contract,
          contract_month_year: null,
          high: null,
          low: null,
          open: null,
          openinterest: null,
          prev_close: null,
          prev_date: null,
          time: timeParseNoNull2(data.time),
        };
      } else if (channel === "fxmkt_intraday") {
        msg = { ...data };
        msg.prev_date = timeParseNoNull2(msg.prev_date);
        msg.time = timeParseNoNull2(msg.time);
      } else if (channel === "cme") {
        msg = { ...data };
        msg.prev_date = timeParseNoNull2(msg.prev_date);
        msg.time = timeParseNoNull2(msg.time);
      } else if (channel === "yahoo_intraday") {
        let time = timeParseNoNull2(data.time);
        if (
          time &&
          time.getHours() === 0 &&
          time.getMinutes() === 0 &&
          time.getSeconds() === 0
        ) {
          const now = new Date();
          time.setHours(now.getHours());
          time.setMinutes(now.getMinutes() - 5);
          time.setSeconds(now.getSeconds());
          time.setMilliseconds(now.getMilliseconds());
        }
        msg = {
          change: null,
          close: data.close,
          continuous_contract: null,
          contract: data.contract,
          contract_month_year: null,
          high: null,
          low: null,
          open: null,
          openinterest: null,
          prev_close: null,
          prev_date: null,
          time,
        };
      }
      if (msg) this.receiveMessage(msg);
    },
    receiveMessage(message) {
      if (this.listenerKeys.includes(message["contract"])) {
        let sendTo = this.listeners[message["contract"]];
        for (const num of sendTo) {
          this[this.messageField(num + 1)] = message;
          for (const key in message) {
            this[this.messageField(num + 1)][key] = message[key];
          }
        }
      }
    },
  },
  beforeDestroy() {
    this._disconnectIntraday();
    selectAll(".tooltip").remove();
  },
  filters: {},
};
</script>

<style scoped></style>
